import { Component, HostBinding, Input } from '@angular/core';
import { AdminSettingsService } from '../../pages/full-layout-page/admin-services/adminsettings-services.service';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent{
    copyRightMsg:String;
    currentDate : Date = new Date();
    @Input('centerFooter') cfooter: boolean;

    constructor(public adminSettingsService: AdminSettingsService,) {
        this.copyRightMsg='';
        this.adminSettingsService.copyrightMsg.subscribe(res => {
            this.copyRightMsg=res;
          });
     }
}
